@if (car) {
  <app-main>
    <div class="car-detail">
      <app-section>
        <app-content [size]="'max'">
          <app-car-detail-gallery [id]="car.aaaid" [items]="car.gallery ?? []" [three-sixty]="car.gallery360URL" [title]="car.make.title + ' ' + (car.hiddenModel ? undefined : car.model.title) + car.engine?.title ? ' ' + car.engine?.title : '' + car.model.lineTitle ? ', ' + car.model.lineTitle : ''">
            <app-car-detail-header>
              <app-car-detail-header-left [in-stock]="car.isAvailable" [branch-id]="car.adminToolbox?.branchId">
                <app-car-detail-header-title class="notranslate">{{ car.make.title }} {{ car.hiddenModel ? undefined : car.model.title }}{{ car.engine?.title ? ' ' + car.engine?.title : '' }}{{ car.model.lineTitle ? ', ' + car.model.lineTitle : '' }}</app-car-detail-header-title>
                <app-car-detail-list>
                  @if (car.productionYear) {
                    <app-car-detail-list-item>{{ car.productionYear }}</app-car-detail-list-item>
                  }
                  @if (car.mileage) {
                    <app-car-detail-list-item>{{ car.mileage | thousands }} {{ car.mileageUnit | lowercase }}</app-car-detail-list-item>
                  }
                  @if (car.engine?.is4x4) {
                    <app-car-detail-list-item>4x4</app-car-detail-list-item>
                  }
                  @if (car.availableFrom) {
                    <app-car-detail-list-item>{{ 'carDetail.available' | translate }} {{ car.availableFrom | date: 'd.M.yyyy' }}</app-car-detail-list-item>
                  }
                </app-car-detail-list>
                {{ car.webHeadline }}
              </app-car-detail-header-left>
              <app-car-detail-header-right [price]="car.price" [monthly-payment]="car.payment.defaultWithoutVat" [in-stock]="car.isAvailable" [branch-id]="car.adminToolbox?.branchId">
                <app-button class="car-detail__header-button" [href]="'tel:' + ('globals.contactData.phone' | translate | phone: false : true)" [fullsize]="true">{{ 'carDetail.callUsButton' | translate }}</app-button>
                <app-button class="car-detail__header-button" [type]="'button'" [color]="'important'" [fullsize]="true" [app-modal]="'reservation-modal'" [modal-data]="{ car: car, type: car.isAvailable ? 'reservation' : 'carInfo' }">{{ 'carDetail.reservationButton' | translate }}</app-button>
              </app-car-detail-header-right>
            </app-car-detail-header>
          </app-car-detail-gallery>
        </app-content>
      </app-section>

      <!--<app-popover [id]="'car-detail-buy'" [width]="380" [mobile-title]="'carDetail.popoverTitle' | translate" [high-z-index]="true">
        <app-popover-list>
          <app-popover-list-button [icon]="'car'" [app-modal]="'reservation-modal'" [modal-data]="{ car: car, type: car.isAvailable ? 'reservation' : 'carInfo' }">
            {{ car.isAvailable ? ('carDetail.popoverBooking' | translate) : ('carDetail.popoverRequestCar' | translate) }}
          </app-popover-list-button>
          <app-popover-list-button [icon]="'deal'" [route]="globals.routes()['onlineForm'].url" [params]="{ car: car.id }">
            {{ 'carDetail.popoverBuyNow' | translate }}
          </app-popover-list-button>
          @if (car.paymentOptions.length) {
            <app-popover-list-button [icon]="'finance'" [route]="globals.routes()['financingForm'].url" [params]="{ car: car.id }" [fragment]="'months=60&advance=' + car.paymentOptions[0].paymentPlans[5].advancePrice">
              {{ 'carDetail.popoverFinancing' | translate }}
            </app-popover-list-button>
          }
          <app-popover-list-button [icon]="'info'" [app-modal]="'car-info-modal'" [modal-data]="{ car: car }">
            {{ 'carDetail.popoverCarInfo' | translate }}
          </app-popover-list-button>
        </app-popover-list>
      </app-popover>-->

      <app-section id="params" class="car-detail__main">
        <app-content>
          <app-car-detail-params [car]="car"></app-car-detail-params>
        </app-content>
      </app-section>

      <app-section id="info-boxes">
        <app-content>
          <app-car-detail-info-boxes [car]="car"></app-car-detail-info-boxes>
        </app-content>
      </app-section>

      @if (car.evWebModules.stats) {
        <app-section id="electro-stats" class="car-detail__main">
          <app-content>
            <app-car-detail-electro-stats [car]="car"></app-car-detail-electro-stats>
          </app-content>
        </app-section>
      }

      @if (car.equipmentVisible) {
        <app-section id="equipment">
          <app-content>
            <app-car-detail-equipment [equipment]="car.equipmentFinal"></app-car-detail-equipment>
          </app-content>
        </app-section>
      }

      @if (car.price.original !== null) {
        <app-section id="price-compare">
          <app-content>
            <app-car-detail-price-compare [car]="car"></app-car-detail-price-compare>
          </app-content>
        </app-section>
      }

      @if (car.paymentOptions.length) {
        <app-section id="financing-calculator">
          <app-content [plus-top]="'left'" [plus-bottom]="'right'">
            <app-financing-calculator [car]="car"></app-financing-calculator>
          </app-content>
        </app-section>
      }

      <app-section id="contact-us">
        <app-content>
          <div class="car-detail__contact-us">
            <div class="car-detail__contact-us-main">
              <div class="car-detail__contact-us-header">
                <app-title class="car-detail__contact-us-title" [tag]="'h2'" [tag-class]="'h4'">{{ 'carDetail.contactUs.title' | translate }}</app-title>
                @for (item of 'carDetail.contactUs.paragraphs' | translate; track $index) {
                  <app-paragraph>{{ item }}</app-paragraph>
                }
              </div>
              <app-button class="car-detail__contact-us-desktop-button" [outlined]="true" [outline-width]="'thin'" [fullsize]="true" [color]="'light'" [app-modal]="'car-info-modal'" [modal-data]="{ car: car }">{{ 'carDetail.contactUs.button' | translate }}</app-button>
            </div>
            <div class="car-detail__contact-us-list">
              <div class="car-detail__contact-us-list-inner">
                @for (item of 'carDetail.contactUs.benefits' | translate; track $index) {
                  <div class="car-detail__contact-us-list-item">
                    <app-icon-box [icon]="item.icon" [color]="'grey'" [size]="'small'" [rounded]="true"></app-icon-box>
                    {{ item.text }}
                  </div>
                }
              </div>
            </div>
            <app-button class="car-detail__contact-us-mobile-button" [outlined]="true" [outline-width]="'thin'" [fullsize]="true" [color]="'light'" [app-modal]="'car-info-modal'" [modal-data]="{ car: car }">{{ 'carDetail.contactUs.button' | translate }}</app-button>
          </div>
        </app-content>
        <app-car-detail-contact-cards></app-car-detail-contact-cards>
      </app-section>

      <app-section>
        <app-recommender [title]="'carDetail.recommender.title' | translate" [title-color]="'grey'" [list-link]="true" [price-from]="car.price.cash + 1"></app-recommender>
      </app-section>

      <app-section [bottom]="true">
        <div class="car-detail__bottom">
          <app-branch-promo [justify-content]="'space-between'" [gradient]="'dark'">
            <app-branch-promo-content [header]="true">
              <app-branch-promo-intro>
                <app-branch-promo-title>{{ 'carDetail.branchPromo.title' | translate }}</app-branch-promo-title>
                <app-paragraph>{{ 'carDetail.branchPromo.subtitle' | translate }}</app-paragraph>
              </app-branch-promo-intro>
              <app-button [color]="'light'" [outlined]="true" [outline-width]="'thin'" (clicked)="openCarDemandModal()">{{ 'carDetail.branchPromo.inquiryButton' | translate }}</app-button>
            </app-branch-promo-content>
            <app-branch-promo-content>
              <app-contact-bar [title]="'carDetail.branchPromo.bottomTitle' | translate" [title-size]="'min'" [buttons]="'map'">
                <app-paragraph>{{ 'carDetail.branchPromo.bottomDescription' | translate }}</app-paragraph>
              </app-contact-bar>
            </app-branch-promo-content>
          </app-branch-promo>

          <app-map></app-map>

          <app-bottom-bar>
            <div class="car-detail__bottom-bar">
              <app-button class="car-detail__bottom-bar-button"  [href]="'tel:' + ('globals.contactData.phone' | translate | phone: false : true)" [fullsize]="true">{{ 'carDetail.callUsButton' | translate }}</app-button>
              <app-button class="car-detail__bottom-bar-button" [type]="'button'" [color]="'important'" [fullsize]="true" [app-modal]="'reservation-modal'" [modal-data]="{ car: car, type: car.isAvailable ? 'reservation' : 'carInfo' }">{{ 'carDetail.reservationButton' | translate }}</app-button>
            </div>
          </app-bottom-bar>
        </div>
      </app-section>
    </div>
  </app-main>
}
